import { render, staticRenderFns } from "./GoToClient.vue?vue&type=template&id=47c700bd"
import script from "./GoToClient.vue?vue&type=script&lang=js"
export * from "./GoToClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports